import { CraAttributeName, Score, TreatmentType } from "@keita/lanepatrol-sdk";
import { HlaAttributeName } from "./HlaAttribute";

export enum MapColoringType {
  Score = "Score",
  Treatment = "Treatment",
  CraAttribute = "CraAttribute",
  HlaAttribute = "HlaAttribute",
}

export interface MapColoringScore {
  type: MapColoringType.Score;
  scoreKey: keyof Score;
}

export interface MapColoringTreatment {
  type: MapColoringType.Treatment;
  treatmentType: TreatmentType;
}

export interface CraColoringAttribute {
  type: MapColoringType.CraAttribute;
  attributeName: CraAttributeName;
}

export interface HlaColoringAttribute {
  type: MapColoringType.HlaAttribute;
  attributeName: HlaAttributeName;
}

export type MapColoring =
  | MapColoringScore
  | MapColoringTreatment
  | CraColoringAttribute
  | HlaColoringAttribute;
